<template>
  <div class="chart-container">
    <div class='problem-solving-chart' ref="problemSolvingChart"></div>
    <div class="footer">
      <div v-if="problemSolvingData.length > 0" class="color-list">
        <div v-for="(item, index) in problemSolvingData" class="color-item" :key="index" :style="{ backgroundColor: value[index].itemStyle.color }"></div>
      </div>
      <span class="no footer-item">No</span>
      <span class="basic footer-item">BASIC</span>
      <span class="capable footer-item">CAPABLE</span>
      <span class="advanced footer-item">ADVANCED</span>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => [],
      required: true
    },
    jobId: {
      required: true
    }
  },
  data () {
    return {
      problemSolvingData: [],
      seriesData: [],
      chart: null
    }
  },
  computed: {
    option () {
      const option = {
        xAxis: {
          type: 'category',
          data: ['count_0', 'count_1', 'count_2', 'count_3', 'count_4', 'count_5'],
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            interval: 0
          },
          axisLabel: true
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: false
        },
        grid: {
          show: true,
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        series: [
          {
            data: this.value,
            type: 'bar',
            barWidth: '80%',
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 3
            }
          }
        ]
      }
      return option
    }
  },
  created () {
    this.loadProblemSolvingFit()
  },
  mounted () {
    this.initProblemSolvingFitChart()
  },
  methods: {
    ...mapActions('application', ['getProblemSolvingFitCount']),
    async loadProblemSolvingFit () {
      const resp = await this.getProblemSolvingFitCount({ job_id: this.jobId })
      if (resp) {
        _.forEach(resp, item => {
          const info = {
            name: item.name,
            value: item.count,
            selected: false,
            itemStyle: {
              color: '#dbdbdb'
            }
          }
          this.problemSolvingData.push({ ...info })
          this.value.push({ ...info })
          this.seriesData.push({ ...info })
        })
        this.$nextTick(() => {
          this.initProblemSolvingFitChart()
        })
      }
    },
    initProblemSolvingFitChart () {
      const el = this.$refs.problemSolvingChart
      const chart = echarts.init(el)
      this.chart = chart
      chart.setOption(this.option)

      chart.getZr().off('click')
      chart.getZr().on('click', (event) => {
        const pointInPixel = [event.offsetX, event.offsetY]
        if (chart.containPixel('grid', pointInPixel)) {
          const xIndex = parseInt(chart.convertFromPixel({ seriesIndex: 0 }, [event.offsetX, event.offsetY])[0])
          const value = this.value
          if (!value[xIndex]) {
            return
          }
          if (value[xIndex].selected) {
            value[xIndex].selected = false
            // 通过改变值改变柱状条高度
            // const count = this.problemSolvingData[xIndex].value
            // value[xIndex].value = count
            value[xIndex].itemStyle.color = '#dbdbdb'
            this.seriesData = [...value]
            this.$emit('change', value)
            chart.setOption(this.option)
            return
          }
          value[xIndex].selected = true
          value[xIndex].itemStyle.color = '#0096cc'
          this.seriesData = [...value]
          this.$emit('change', value)
          chart.setOption(this.option)
        }
      })
    },
    resetChart () {
      if (this.value.length < 1) {
        this.value.push(..._.cloneDeep(this.problemSolvingData))
      }
      const value = this.value
      _.forEach(value, item => {
        if (item.selected) {
          item.itemStyle.color = '#0096cc'
        } else {
          item.itemStyle.color = '#dbdbdb'
        }
      })
      this.chart.setOption(this.option)
    }
  },
  watch: {
    value: {
      handler () {
        this.resetChart()
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
.chart-container {
  background-color: #fff;

  .problem-solving-chart {
    position: relative;
    width: 100%;
    height: 60px;

    &::after {
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #e4efed;
    }
  }

  .footer {
    display: flex;
    font-size: 12px;
    color: #fff;
    text-align: center;
    position: relative;

    .footer-item {
      flex: 2;
      background-color: transparent;
      z-index: 1;

      &.no {
          flex: 1;
          // background-color: #c0c4cc;
        }

      &.basic {
          flex: 1;
        }
    }

    .color-list {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;

      .color-item {
        flex: 1;
      }
    }
  }
}
</style>
